import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../api";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import LocationRequests from "./LocationRequests";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Pagination from "../Homepage/Pagination";

export default function LocationHistory() {
  const [locationHistory, setLocationHistory] = useState([]);
  const [loading, setloading] = useState(false);
  const nav = useNavigate();
  const [showlocationrequests, setshowlocationrequests] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(1);
  const [search, setSearch] = useState("");
  const [isEnter, setIsEnter] = useState(false);
  const [pagecount, setpagecount] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/LocationHistory/GetAllLocationHistory?search=${search}&page=${page}`
      )
      .then((res) => {
        setLocationHistory(res.data?.data);
        setpagecount(res.data?.pages);
        setTotal(res.data?.count);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh, isEnter, page]);

  return (
    <section className="technician-vouchers">
      <h1>Location History</h1>
      <button
        onClick={() => {
          setshowlocationrequests(true);
        }}
        id="ViewRequestsLocationHistoryTechnician"
      >
        View Requests
      </button>
      <input
        type="search"
        placeholder="Enter Search Keyword"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setLocationHistory([]);
            setIsEnter(!isEnter);
            setpage(1);
          }
        }}
      />
      <p>
        <strong>Total: </strong>
        {total}
      </p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(12, 1fr)" }}>
              <blockquote>Id</blockquote>
              <blockquote style={{ minWidth: "20rem" }}>Username</blockquote>
              <blockquote style={{ minWidth: "20rem" }}>Ticket Id</blockquote>
              <blockquote style={{ minWidth: "20rem" }}>
                From Location
              </blockquote>
              <blockquote style={{ minWidth: "20rem" }}>To Location</blockquote>
              <blockquote style={{ minWidth: "20rem" }}>Start Time</blockquote>
              <blockquote style={{ minWidth: "20rem" }}>
                Expected End Time
              </blockquote>
              <blockquote style={{ minWidth: "20rem" }}>
                Actual End Time
              </blockquote>
              <blockquote style={{ minWidth: "20rem" }}>Status</blockquote>
              <blockquote style={{ minWidth: "15rem", gridColumn: "span 2" }}>
                Actions
              </blockquote>
            </aside>
          </div>
          <div>
            {locationHistory.length > 0 ? (
              <>
                {locationHistory.map((x) => (
                  <aside style={{ gridTemplateColumns: "repeat(12, 1fr)" }}>
                    <blockquote>{x.id}</blockquote>

                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.technicianUserId}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x?.ticket?.seriesId}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.fromLocationLatitude}, {x.fromLocationLongitude}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.toLocationLatitude}, {x.toLocationLongitude}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {moment
                        .utc(x.startTime)
                        .local()
                        .format("DD/MM/YYYY HH:mm:ss")}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {moment
                        .utc(x.expectedEndTime)
                        .local()
                        .format("DD/MM/YYYY HH:mm:ss")}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.actualEndTime
                        ? moment
                            .utc(x.actualEndTime)
                            .local()
                            .format("DD/MM/YYYY HH:mm:ss")
                        : "N/A"}
                    </blockquote>
                    <blockquote style={{ minWidth: "20rem" }}>
                      {x.visitStatus}
                    </blockquote>
                    <blockquote
                      style={{ minWidth: "5rem" }}
                      onClick={() => {
                        nav(`/dashboard/technician/view-location/${x.id}`);
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>

                    <blockquote
                      style={{ minWidth: "5rem" }}
                      onClick={() => {
                        Swal.fire({
                          icon: "error",
                          title: "Delete Location History",
                          text: "Are you sure you want to delete location history?",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/LocationHistory/DeleteLocationHistory/${x.id}`
                              )
                              .then((res) => {
                                toast.success(res.data, {
                                  position: "bottom-center",
                                });
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  </aside>
                ))}
                {loading && (
                  <aside style={{ gridTemplateColumns: "repeat(12, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 12" }}>
                      <center>
                        <i className="fa-solid fa-spineer fa-2x fa-spin"></i>
                      </center>
                    </blockquote>
                  </aside>
                )}
              </>
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(12, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 12" }}>
                  No Records Found
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      <Pagination count={pagecount} setpagenumber={setpage} pagenumber={page} />
      {showlocationrequests && (
        <LocationRequests
          setshowlocationrequests={setshowlocationrequests}
          set_refresh={setrefresh}
          re_fresh={refresh}
        />
      )}
    </section>
  );
}
